import { hasClinicianNoteContent } from '@/helpers/hasClinicianNoteContent';
import { ContextDocumentStatus } from '@heidi/schema/ml-scribe';

type ContextFileSource = {
  status?: ContextDocumentStatus | null;
};

type SessionContextSourcesInput = {
  clinicianNotes?: string[] | null;
  contextFiles?: ReadonlyArray<ContextFileSource> | null;
  linkedPatientDocuments?: ReadonlyArray<unknown> | null;
};

export type SessionContextSources = {
  hasTextContext: boolean;
  hasReadyContextFiles: boolean;
  hasLinkedPatientDocuments: boolean;
  hasPendingContextFiles: boolean;
  hasUsableContext: boolean;
};

/** Classifies context sources by whether generation can consume them now. */
export const getSessionContextSources = ({
  clinicianNotes,
  contextFiles,
  linkedPatientDocuments,
}: SessionContextSourcesInput): SessionContextSources => {
  const hasTextContext = hasClinicianNoteContent(clinicianNotes);
  const hasReadyContextFiles =
    contextFiles?.some(
      (file) =>
        file.status === ContextDocumentStatus.READY ||
        file.status === ContextDocumentStatus.READY_WITH_HIGH_TOKEN_COUNT
    ) ?? false;
  const hasLinkedPatientDocuments = (linkedPatientDocuments?.length ?? 0) > 0;
  const hasPendingContextFiles =
    contextFiles?.some(
      (file) => !file.status || file.status === ContextDocumentStatus.PARSING
    ) ?? false;

  return {
    hasTextContext,
    hasReadyContextFiles,
    hasLinkedPatientDocuments,
    hasPendingContextFiles,
    hasUsableContext: hasTextContext || hasReadyContextFiles || hasLinkedPatientDocuments,
  };
};
